// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-tab-container {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  background: transparent;
  margin-bottom: 0;
  gap: 8px;
}

.navigation-tab {
  background: none;
  border: none;
  font: inherit;
  color: var(--color-dark-gray);
  padding: 12px 8px 8px 8px;
  cursor: pointer;
  transition: color 0.2s ease;
  flex: 1 1 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.navigation-tab:hover {
  color: var(--color-dark-gray);
}

.navigation-tab.active {
  color: var(--color-primary-green);
  border-bottom: 2px solid var(--color-primary-green);
}

.navigation-tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.navigation-tab.active .navigation-tab-icon {
  color: var(--color-primary-green);
}

.navigation-tab.active .navigation-tab-label {
  color: var(--color-primary-green);
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .navigation-tab-container {
    gap: 4px;
  }
  
  .navigation-tab {
    padding: 8px 4px 6px 4px;
  }
}

/* Mobile Navigation Tab */
.navigation-tab-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  width: 100%;
}

.navigation-tab-mobile-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary-green);
}

.navigation-tab-mobile-date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.navigation-tab-mobile-text {
  color: var(--color-primary-green);
}

.navigation-chevron {
  color: var(--color-dark-gray) !important;
  background: none !important;
  border: none !important;
  padding: 8px !important;
  cursor: pointer !important;
  transition: color 0.2s ease !important;
}

.navigation-chevron:hover {
  color: var(--color-primary-green) !important;
  background-color: var(--accent-soft) !important;
} `, "",{"version":3,"sources":["webpack://./src/components/NavigationTab/NavigationTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kCAAkC;AAClC;EACE;IACE,QAAQ;EACV;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD","sourcesContent":[".navigation-tab-container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  width: 100%;\n  background: transparent;\n  margin-bottom: 0;\n  gap: 8px;\n}\n\n.navigation-tab {\n  background: none;\n  border: none;\n  font: inherit;\n  color: var(--color-dark-gray);\n  padding: 12px 8px 8px 8px;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  flex: 1 1 0;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.navigation-tab:hover {\n  color: var(--color-dark-gray);\n}\n\n.navigation-tab.active {\n  color: var(--color-primary-green);\n  border-bottom: 2px solid var(--color-primary-green);\n}\n\n.navigation-tab-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.navigation-tab.active .navigation-tab-icon {\n  color: var(--color-primary-green);\n}\n\n.navigation-tab.active .navigation-tab-label {\n  color: var(--color-primary-green);\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 768px) {\n  .navigation-tab-container {\n    gap: 4px;\n  }\n  \n  .navigation-tab {\n    padding: 8px 4px 6px 4px;\n  }\n}\n\n/* Mobile Navigation Tab */\n.navigation-tab-mobile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: transparent;\n  width: 100%;\n}\n\n.navigation-tab-mobile-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-primary-green);\n}\n\n.navigation-tab-mobile-date {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n}\n\n.navigation-tab-mobile-text {\n  color: var(--color-primary-green);\n}\n\n.navigation-chevron {\n  color: var(--color-dark-gray) !important;\n  background: none !important;\n  border: none !important;\n  padding: 8px !important;\n  cursor: pointer !important;\n  transition: color 0.2s ease !important;\n}\n\n.navigation-chevron:hover {\n  color: var(--color-primary-green) !important;\n  background-color: var(--accent-soft) !important;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
